module.exports = __webpack_public_path__ + "static/media/clothes-4.2cd678f4.jpg";